import { styled } from '@frontend/theme';

export const EmailText = styled('span')(({ theme }) => ({
  color: theme.palette.neutral[500],
  fontWeight: 500,
}));
